<template>
  <NuxtLayout name="website">
    <PebbleWebsiteHero />
    <PebbleWebsiteFeature />
    <PebbleWebsiteFAQs />
    <!-- <PebbleWebsitePackages /> -->
    <!-- <PebbleWebsiteSubscription /> -->
    <PebbleWebsiteFooter />
  </NuxtLayout>
</template>
<script lang="ts" setup>
import {
  PebbleWebsiteHero,
  PebbleWebsiteFeature,
  PebbleWebsiteFAQs,
  PebbleWebsitePackages,
  PebbleWebsiteSubscription,
  PebbleWebsiteFooter,
} from "#components";

usePageTitle({
  title: "Home",
  description: "Home",
});
</script>
